import type { Form, SelectInventoryFormFields } from './types';

export const toggleItem = (
  tokenId: `${number}`,

  array: SelectInventoryFormFields['items']
): SelectInventoryFormFields['items'] => {
  const arr = array.slice(0);
  const index = arr.findIndex((x) => x.tokenId === tokenId);

  if (index > -1) {
    // Item exists in the array, remove it
    arr.splice(index, 1);
  } else {
    // Item doesn't exist in the array, add it
    arr.push({
      tokenId,
      quantity: 1n,
    });
  }

  return arr;
};

export const onQuantityChange = (
  tokenId: `${number}`,
  amount: bigint,
  items: SelectInventoryFormFields['items'],
  setValue: Form['setValue'],
  maxQuantity: bigint
) => {
  const selectedItem = items.find((x) => x.tokenId === tokenId);

  if (amount > maxQuantity) {
    amount = maxQuantity;
  } else if (amount < 0n) {
    amount = 0n;
  }

  if (selectedItem && amount > 0n) {
    setValue(
      'items',
      items.map((item) => {
        if (item.tokenId === tokenId) {
          return {
            tokenId: item.tokenId,
            quantity: amount,
          };
        }

        return item;
      })
    );
  } else if (selectedItem && amount === 0n) {
    setValue(
      'items',
      items.filter((item) => item.tokenId !== tokenId)
    );
  } else if (!selectedItem && amount > 0n) {
    setValue('items', [...items, { tokenId, quantity: amount }]);
  }
};
